import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type EmergencyHomeFillProps = IconComponentBaseProps;

export const EmergencyHomeFill = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.red[6],
  className,
}: EmergencyHomeFillProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_7277_12902"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_7277_12902)">
        <path
          d="M12 21.4C11.7653 21.4 11.5385 21.3542 11.3195 21.2625C11.1005 21.1708 10.9004 21.041 10.7193 20.873L3.12701 13.2808C2.95901 13.0996 2.82917 12.8995 2.73751 12.6805C2.64584 12.4615 2.60001 12.2347 2.60001 12C2.60001 11.7653 2.64517 11.5358 2.73551 11.3115C2.82601 11.0872 2.95651 10.8898 3.12701 10.7193L10.7193 3.12701C10.9004 2.94367 11.1005 2.81001 11.3195 2.72601C11.5385 2.64201 11.7653 2.60001 12 2.60001C12.2347 2.60001 12.4642 2.64267 12.6885 2.72801C12.9128 2.81317 13.1103 2.94617 13.2808 3.12701L20.873 10.7193C21.0538 10.8898 21.1868 11.0864 21.272 11.3093C21.3573 11.5321 21.4 11.7623 21.4 12C21.4 12.2347 21.358 12.4615 21.274 12.6805C21.19 12.8995 21.0563 13.0996 20.873 13.2808L13.2808 20.873C13.1103 21.0435 12.9136 21.174 12.6908 21.2645C12.4679 21.3548 12.2377 21.4 12 21.4ZM12.0003 13.0865C12.2129 13.0865 12.391 13.0147 12.5345 12.871C12.6782 12.7272 12.75 12.549 12.75 12.3365V8.22126C12.75 8.00876 12.6781 7.83059 12.5343 7.68676C12.3904 7.54309 12.2123 7.47126 11.9998 7.47126C11.7871 7.47126 11.609 7.54309 11.4655 7.68676C11.3218 7.83059 11.25 8.00876 11.25 8.22126V12.3365C11.25 12.549 11.3219 12.7272 11.4658 12.871C11.6096 13.0147 11.7878 13.0865 12.0003 13.0865ZM12 15.702C12.2288 15.702 12.4207 15.6246 12.5755 15.4698C12.7303 15.3149 12.8078 15.1231 12.8078 14.8943C12.8078 14.6654 12.7303 14.4736 12.5755 14.3188C12.4207 14.1639 12.2288 14.0865 12 14.0865C11.7712 14.0865 11.5793 14.1639 11.4245 14.3188C11.2697 14.4736 11.1923 14.6654 11.1923 14.8943C11.1923 15.1231 11.2697 15.3149 11.4245 15.4698C11.5793 15.6246 11.7712 15.702 12 15.702Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
